// ABOUTME: The screen registry: screen ID to the component that draws it. Keyed by ID, with no hand-kept union of IDs.
// ABOUTME: Stage 2 adds one entry per moved screen; the contract test checks the registry against the generated definition.

import type { ScreenComponent } from './screenContract';
import Screen1A from '../screens/Screen1A';
import Screen2A from '../screens/Screen2A';
import Screen2B from '../screens/Screen2B';
import Screen2C from '../screens/Screen2C';
import Screen2D from '../screens/Screen2D';
import Screen3A from '../screens/Screen3A';
import Screen4A from '../screens/Screen4A';
import Screen4B from '../screens/Screen4B';
import Screen5B from '../screens/Screen5B';
import Screen5C from '../screens/Screen5C';
import Screen5D from '../screens/Screen5D';

export const SCREEN_REGISTRY: Record<string, ScreenComponent> = {
  '1A': Screen1A,
  '2A': Screen2A,
  '2B': Screen2B,
  '2C': Screen2C,
  '2D': Screen2D,
  '3A': Screen3A,
  '4A': Screen4A,
  '4B': Screen4B,
  '5B': Screen5B,
  '5C': Screen5C,
  '5D': Screen5D,
};
